import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { HeadingText, BodyText } from '@paypalcorp/pp-react-text';

import getLocaleMessages from '../../../utils/localesMessages';
import { isDonateButton } from '../../../utils/buttonFactoryUtils';

const { button, link } = getLocaleMessages('buttonsV3/stepHeader');

const StepHeader = ({ currentStep }) => {
  const stepHeaders = isDonateButton()
    ? button?.[currentStep]
    : link?.[currentStep];

  return stepHeaders ? (
    <header>
      <HeadingText className="step-header">{stepHeaders.header}</HeadingText>
      <BodyText>{stepHeaders.subheader}</BodyText>
    </header>
  ) : null;
};

StepHeader.propTypes = {
  currentStep: PropTypes.number,
};

const mapStateToProps = (state) => {
  const { buttonFactoryV3: { currentStep } = {} } = state;

  return {
    currentStep,
  };
};

export default connect(mapStateToProps)(StepHeader);
